import React from 'react'

const CustomRasterIcon = (props) => {
    const { size, image: Image } = props;
    return (
        <img src={Image} height={size} />
    )
}

export default React.memo(CustomRasterIcon)